import PropTypes from 'prop-types';
import unitConverter from 'convert-units';
import { sluggify } from './utils';

export const loadTypes = ['boxes', 'pallets'];
export const weightUnits = unitConverter().possibilities('mass');
export const dimensionalUnits = unitConverter().possibilities('length');
export const distanceUnits = unitConverter().possibilities('length');
export const temperatureUnits = unitConverter().possibilities('temperature');
export const DEFAULT_TEMPERATURE_UNIT = DEFAULT_TEMPERATURE_UNITS;
export const DEFAULT_WEIGHT_UNIT = DEFAULT_WEIGHT_UNITS;
export const DEFAULT_DIMENSIONAL_UNIT = DEFAULT_DIMENSIONAL_UNITS;
export const DEFAULT_DISTANCE_UNIT = DEFAULT_DISTANCE_UNITS;
export const loadSchema = {
  quantity: PropTypes.number,
  stackable: PropTypes.bool,
  width: PropTypes.number,
  length: PropTypes.number,
  height: PropTypes.number,
  weight: PropTypes.number,
  type: PropTypes.oneOf([...loadTypes]),
  weight_units: PropTypes.oneOf([...weightUnits]),
  dimensional_units: PropTypes.oneOf([...dimensionalUnits]),
};

const generateLoadDefaults = () => {
  switch (DEFAULT_DIMENSIONAL_UNITS) {
    case 'in':
      return {
        type: 'pallets',
        quantity: 1,
        length: 48,
        width: 40,
        height: 60,
        weight: 0,
        weight_units: DEFAULT_WEIGHT_UNITS,
        dimensional_units: DEFAULT_DIMENSIONAL_UNITS,
      };
    case 'cm':
      return {
        type: 'pallets',
        quantity: 1,
        length: 120,
        width: 100,
        height: 100,
        weight: 0,
        weight_units: DEFAULT_WEIGHT_UNITS,
        dimensional_units: DEFAULT_DIMENSIONAL_UNITS,
      };

    default:
      return {
        type: 'pallets',
        quantity: 1,
        length: 48,
        width: 40,
        height: 60,
        weight: 0,
        weight_units: DEFAULT_WEIGHT_UNITS,
        dimensional_units: DEFAULT_DIMENSIONAL_UNITS,
      };
  }
};

export const defaultLoad = generateLoadDefaults();
export const loadTypesOptions = [
  {
    localizationSlug: 'PALLETS',
    name: 'Pallets',
    value: 'pallets',
  },
  {
    localizationSlug: 'BOXES',
    name: 'Boxes',
    value: 'boxes',
  },
];
const listOutUnitDetails = (measure) => {
  return unitConverter()
    .list(measure)
    .map((item) => ({
      localizationSlug: sluggify(item.singular),
      name: item.abbr,
      value: item.abbr,
      singular: item.singular,
      plural: item.plural,
    }));
};
export const weightUnitsOptions = listOutUnitDetails('mass');
export const lengthUnitsOptions = listOutUnitDetails('length');
export const distanceUnitsOptions = listOutUnitDetails('length');
export const temperatureUnitsOptions = listOutUnitDetails('temperature');
